import { APICallV2Post } from './APICall';

export class RemoveApiCall extends APICallV2Post {
    _method = 'file/remove';
}

export class RemoveWeblinkApiCall extends APICallV2Post {
    _method = 'weblinks/file/remove';
}
